import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompanyService } from 'src/app/services/companyService';
import { UserDataService } from 'src/app/services/users.service';
import { UserSessionService } from 'src/app/services/user-session.service';

@Component({
  selector: 'app-subject-section-search-dialog',
  templateUrl: './subject-section-search-dialog.component.html',
})
export class SubjectSectionSearchDialogComponent implements OnInit {

  form: FormGroup;

  operators: any[] = [];
  companies: any[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SubjectSectionSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userDataService: UserDataService,
    private userSessionService: UserSessionService,
  ) {
    this.form = this.fb.group({
      companyId: [data?.rawSelections?.companyId ?? data?.companyId ?? []],
      responsible: [data?.rawSelections?.responsible ?? data?.responsible ?? []],
      name: [data?.name ?? ''],
      surname: [data?.surname ?? ''],
      legalEntity: [data?.legalEntity ?? ''],
      telephone1: [data?.telephone1 ?? ''],
      telephone2: [data?.telephone2 ?? ''],
      email: [data?.email ?? ''],
      streetName: [data?.streetName ?? ''],
      city: [data?.city ?? ''],
      state: [data?.state ?? ''],
    });
  }

  ngOnInit(): void {
    const user = this.userSessionService.getState('user');

    // responsible è disabilitato finché non viene selezionata almeno una company
    this.form.get('responsible')?.disable();

    // Reagisce alle variazioni di companyId per caricare gli operatori
    this.form.get('companyId')?.valueChanges.subscribe((selectedCompanies: any[]) => {
      if (!selectedCompanies || selectedCompanies.length === 0) {
        this.form.get('responsible')?.disable();
        this.form.get('responsible')?.setValue([]);
        this.operators = [];
      } else {
        const codes = selectedCompanies.map((c: any) => c.code);
        this.userDataService.getByCompanyCode(codes).subscribe((comps: any[]) => {
          const opList: any[] = [];
          const users = comps.filter((usr: any) => usr.email !== null && usr.email !== undefined && usr.email.trim() !== '');
          users.forEach((element: any) => {
            element.UsersCompaniesRel.forEach((element2: any) => {
              if (codes.includes(element2.code)) {
                opList.push(element);
              }
            });
          });
          const operatorList = [...new Set(opList)];
          this.operators = operatorList.sort((a: any, b: any) => a.email <= b.email ? -1 : 1);
          this.form.get('responsible')?.enable();
          // Ripristina la selezione salvata degli operatori
          const saved: any[] = this.data?.rawSelections?.responsible ?? this.data?.responsible ?? [];
          if (saved.length) {
            const matched = this.operators.filter(o => saved.some((s: any) => s.id === o.id));
            if (matched.length) this.form.patchValue({ responsible: matched });
          }
        });
      }
    });
    this.companies = user.UsersCompaniesRel.filter((company: any) => company.isOpen == true && company.type != 'DR').sort((a: any, b: any) =>
      (a.code ?? '').toLowerCase() <= (b.code ?? '').toLowerCase() ? -1 : 1
    );
    // Il patchValue su companyId attiva la subscription valueChanges sopra,
    // che si occuperà anche di caricare gli operatori e ripristinare la selezione
    const savedCompanies: any[] = this.data?.rawSelections?.companyId ?? this.data?.companyId ?? [];
    if (savedCompanies.length) {
      const matched = this.companies.filter((c: any) => savedCompanies.some((s: any) => s.id === c.id));
      if (matched.length) this.form.patchValue({ companyId: matched });
    }
  }

  search(): void {
    const raw = this.form.getRawValue();
    this.dialogRef.close({
      ...raw,
      rawSelections: {
        companyId: raw.companyId,
        responsible: raw.responsible,
      }
    });
  }

  reset(): void {
    this.form.reset({
      companyId: [],
      responsible: [],
      name: '',
      surname: '',
      legalEntity: '',
      telephone1: '',
      telephone2: '',
      email: '',
      streetName: '',
      city: '',
      state: '',
    });
  }

  removeSelection(field: string, item: any): void {
    const current: any[] = this.form.get(field)?.value ?? [];
    this.form.get(field)?.setValue(current.filter(i => i !== item));
  }

  clearField(field: string): void {
    this.form.get(field)?.setValue('');
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
